import React from 'react';
import ConfirmationModal from '../../../ui/ConfirmationModal/EditTabsConfirmationModal';
import CertificateViewerModal from '../../../ui/CertificateViewerModal/CertificateViewerModal';

import { ProfessionalPersonalInfoTab } from './TabsContents/ProfessionalPersonalInfoTab';
import { ProfessionalStudiesTab } from './TabsContents/ProfessionalStudiesTab';
import { ProfessionalProfileTab } from './TabsContents/ProfessionalProfileTab';
import { ProfessionalFaqsTab } from './TabsContents/ProfessionalFaqsTab';

import { useProfessionalEditTabs } from './hooks/useProfessionalEditTabs';
import styles from './ProfessionalEditTabs.module.scss';
import { ProfessionalEditTabsProps } from './types/ProfessionalEditTabs.types';

const ProfessionalEditTabs: React.FC<ProfessionalEditTabsProps> = (props) => {
    const { editMode = false, studies, onStudiesChange } = props;

    const {
        t, derivedProfessions, specialties,
        loadingSpecialties, errorSpecialties, openConfirmModal,
        handleOpenConfirm, handleCloseConfirm, executeDeleteStudy,
        viewerOpen, selectedCert, handleOpenViewer, handleCloseViewer
    } = useProfessionalEditTabs({ 
        studies, 
        editMode, 
        onStudiesChange, 
        details: props.details, 
        onDetailsChange: props.onDetailsChange 
    });

    return (
        <section className={styles['edit-tabs']}>
            <div className={styles['edit-tabs__content']} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <div className={styles['edit-tabs__card']}>
                    <ProfessionalPersonalInfoTab
                        editMode={editMode}
                        professionalInfo={props.professionalInfo}
                        details={props.details}
                        onDetailsChange={props.onDetailsChange}
                        errors={props.errors}
                        professionalInfoSettings={props.professionalInfoSettings}
                    />
                </div>
                
                <div className={styles['edit-tabs__card']}>
                    <ProfessionalStudiesTab
                        editMode={editMode}
                        studies={props.studies}
                        onStudiesChange={props.onStudiesChange}
                        errors={props.errors}
                        handleOpenViewer={handleOpenViewer}
                        handleOpenConfirm={handleOpenConfirm}
                        availableTags={specialties as any}
                        loadingTags={loadingSpecialties}
                        errorTags={errorSpecialties}
                    />
                </div>

                {editMode && (
                    <div className={styles['edit-tabs__card']}>
                        <ProfessionalProfileTab
                            editMode={editMode}
                            professions={derivedProfessions}
                            details={props.details}
                            onDetailsChange={props.onDetailsChange}
                            errors={props.errors}
                            loadingSpecialties={loadingSpecialties}
                        />
                    </div>
                )}
                
                <ProfessionalFaqsTab editMode={editMode} />
            </div>

            <ConfirmationModal
                open={openConfirmModal}
                onClose={handleCloseConfirm}
                onConfirm={executeDeleteStudy}
                title={t('appAdmin.EditTabsComponent.confirmDeleteTitle')}
                description={t('appAdmin.EditTabsComponent.confirmDeleteDescription')}
                confirmText={t('appAdmin.EditTabsComponent.deleteConfirm')}
                confirmColor="error"
            />

            <CertificateViewerModal
                open={viewerOpen}
                onClose={handleCloseViewer}
                fileUrl={selectedCert.url}
                fileName={selectedCert.name}
                fileType={selectedCert.type}
            />
        </section>
    );
}

export default ProfessionalEditTabs;